import { render, staticRenderFns } from "./CodeBatchListView.vue?vue&type=template&id=5828df2c&scoped=true"
import script from "./CodeBatchListView.vue?vue&type=script&lang=js"
export * from "./CodeBatchListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5828df2c",
  null
  
)

export default component.exports